import styled from 'styled-components';
import { animation } from 'utils';

export const Container = styled.div`
  height: ${({ $fullHeight }) => ($fullHeight ? '85vh' : 'unset')};
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Loading = styled.div`
  width: ${({ $size }) => $size || 48}px;
  height: ${({ $size }) => $size || 48}px;
  border-width: ${({ $width }) => $width || 6}px;
  border-color: ${({ $size }) => ($size ? 'white' : 'grey')};
  border-style: solid;
  border-bottom-color: transparent;
  border-radius: 50%;
  box-sizing: border-box;
  animation: ${animation.rotation} 0.7s linear infinite;
`;
